import type { VeterinarianOffice } from '@/models/DTO/veterinarian-office/veterinarian-office.model'
import type { VeterinarianOfficeUser } from '@/models/DTO/veterinarian-office-user/veterinarian-office-user.model'
import { BaseAPIService } from './base-api.service'

const API_VERSION: string = import.meta.env.VITE_API_VERSION
const BASE_URL = `/api/v${API_VERSION}/VeterinarianOffices`
const BY_ID_URL = `${BASE_URL}/:id`
const USERS_FOR_OFFICE_URL = `${BASE_URL}/:id/Users`

export interface IVeterinarianOfficesService {
  getAll(): Promise<VeterinarianOffice[]>
  getById(id: string): Promise<VeterinarianOffice>
  create(model: VeterinarianOffice): Promise<VeterinarianOffice>
  update(model: VeterinarianOffice): Promise<VeterinarianOffice>
  delete(id: string): Promise<VeterinarianOffice>
  getAllUsersForOffice(id: string): Promise<VeterinarianOfficeUser[]>
}

export class VeterinarianOfficesService implements IVeterinarianOfficesService {
  private readonly _baseAPIService: BaseAPIService

  constructor() {
    this._baseAPIService = new BaseAPIService()
  }

  public async getAll(): Promise<VeterinarianOffice[]> {
    const resp = await this._baseAPIService.client.get<VeterinarianOffice[]>(BASE_URL)
    return resp.data
  }

  public async getById(id: string): Promise<VeterinarianOffice> {
    const resp = await this._baseAPIService.client.get<VeterinarianOffice>(
      BY_ID_URL.replace(':id', id),
    )
    return resp.data
  }

  public async create(model: VeterinarianOffice): Promise<VeterinarianOffice> {
    const resp = await this._baseAPIService.client.post<VeterinarianOffice>(BASE_URL, model)
    return resp.data
  }

  public async update(model: VeterinarianOffice): Promise<VeterinarianOffice> {
    const resp = await this._baseAPIService.client.put<VeterinarianOffice>(
      BY_ID_URL.replace(':id', model.id!),
      model,
    )
    return resp.data
  }

  public async delete(id: string): Promise<VeterinarianOffice> {
    const resp = await this._baseAPIService.client.delete<VeterinarianOffice>(
      BY_ID_URL.replace(':id', id),
    )
    return resp.data
  }

  public async getAllUsersForOffice(id: string): Promise<VeterinarianOfficeUser[]> {
    const resp = await this._baseAPIService.client.get<VeterinarianOfficeUser[]>(
      USERS_FOR_OFFICE_URL.replace(':id', id),
    )
    return resp.data
  }
}
